import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-delegate-empty-state',
    templateUrl: './delegate-empty-state.component.html',
    styleUrls: ['./delegate-empty-state.component.scss'],
    standalone: false
})
export class DelegateEmptyStateComponent implements OnInit {

  constructor(public themeService: ThemeService) { }

  ngOnInit() {
  }

}
